import { createSlice } from "@reduxjs/toolkit";

const intialAgentAdminState = {
  agentAdminDetails: {},
  agentSalesManagerList: {},
  agentOfficeDetails: {},
  agentOfficeList: {},
  agentsDetails: {},
  createAgentAdminDetails: {},
  createAgentOfficeDetails: {},
  updateAgentStatusDetails: {},
  subscriptionHistory: {},
  addSaveCardsData: {},
  salesRepresentativeList: {},
  openUserSettingModalFlag: false,
  tabValueName: null,
  openGoPremiumModalModalFlag: false,
  goToRepresentativeTab: false,
  agentAdminLoader: false,
  agentRepLoader: false,
  createAdminLoader: false,
  isAddBtnClicked: false,
  agentAdminListLoader: false,
  companyDetails: {},
};

const agentsAdmin = createSlice({
  name: "agentAdminDetails",
  initialState: intialAgentAdminState,
  reducers: {
    resetAgentsAdminState: () => intialAgentAdminState,
    getAdminProfileData(state, action) {
      state.agentAdminLoader = true;
    },
    fetchAdminProfileData(state, action) {
      state.agentProfileListData = action.payload;
      state.agentAdminLoader = false;
    },
    getAgentAdminDetails(state, action) {
      state.agentAdminLoader = true;
      state.agentAdminListLoader = true;
    },
    fetchAgentAdminData(state, action) {
      state.agentAdminDetails = action.payload;
      if (action.payload?.all_salesManager) {
        state.agentSalesManagerList = action.payload;
      }
      if (!action.payload?.is_superAdmin) {
        state.agentSalesManagerList = {};
      }
      state.agentAdminLoader = false;
      state.agentAdminListLoader = false;
    },
    createAgentAdminDetails(state, action) {
      state.createAdminLoader = true;
    },
    fetchCreateAgentAdminData(state, action) {
      state.createAgentAdminDetails = action.payload;
      state.createAdminLoader = false;
    },
    getAgentsDetails(state, action) {
      state.agentAdminLoader = true;
    },
    fetchAgentsData(state, action) {
      state.agentsDetails = action.payload;
      state.agentAdminLoader = false;
    },
    getAgentOfficeDetails(state, action) {
      state.agentAdminLoader = true;
    },
    fetchAgentOfficeData(state, action) {
      state.agentOfficeDetails = action.payload;
      if (action.payload?.all_offices) {
        state.agentOfficeList = action.payload;
      }
      if (!action.payload?.is_superAdmin) {
        state.agentOfficeList = {};
      }
      state.agentAdminLoader = false;
    },
    createAgentOfficeDetails(state, action) {
      state.agentAdminLoader = true;
    },
    fetchCreateAgentOfficeData(state, action) {
      state.createAgentOfficeDetails = action.payload;
      state.agentAdminLoader = false;
    },
    updateAgentStatusData(state, action) {
      state.agentAdminLoader = true;
    },
    fetchUpdateAgentStatusData(state, action) {
      state.updateAgentStatusDetails = action.payload;
      state.agentAdminLoader = false;
    },
    openUserSettingModal(state, action) {
      state.openUserSettingModalFlag = action.payload;
    },
    fetchTabValueName(state, action) {
      state.tabValueName = action.payload;
    },
    openGoPremiumModal(state, action) {
      state.openGoPremiumModalModalFlag = action.payload;
    },
    goToRepresentativeTab(state, action) {
      state.goToRepresentativeTab = action.payload;
    },
    getSubscriptionHistoryDetails(state, action) {
      state.agentAdminLoader = true;
    },
    fetchSubscriptionHistoryData(state, action) {
      state.subscriptionHistory = action.payload;
      state.agentAdminLoader = false;
    },
    getAddSaveCardsDetails(state, action) {
      state.agentAdminLoader = true;
    },
    fetchAddSaveCardsData(state, action) {
      state.addSaveCardsData = action.payload;
      state.agentAdminLoader = false;
    },
    getSalesRepresentativeDetails(state, action) {
      state.agentRepLoader = true;
      state.agentAdminListLoader = true;
    },
    fetchSalesRepresentativeData(state, action) {
      state.salesRepresentativeList = action.payload;
      state.agentAdminListLoader = false;
      state.agentRepLoader = false;
    },
    getUserContactDetails(state, action) {
      state.agentRepLoader = true;
    },
    fetchUserContactData(state, action) {
      state.contactformData = action.payload;
      state.agentRepLoader = false;
    },
    fetchIsAddBtnClicked(state, action) {
      state.isAddBtnClicked = action.payload;
    },
    updateCompanyDetails(state, action) {
      state.agentAdminLoader = true;
    },
    fetchUpdateCompanyDetailsData(state, action) {
      state.companyDetails = action.payload;
      state.agentAdminLoader = false;
    },
  },
});
export const agentsAdminAction = agentsAdmin.actions;
export default agentsAdmin.reducer;
